var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 23,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5057 11.7439V11.7439H22.1905C22.6273 11.7439 22.8977 11.2655 22.6689 10.8911L19.5905 5.96146C19.3617 5.60786 18.8625 5.60786 18.6337 5.96146L15.5553 10.8911C15.3265 11.2655 15.5969 11.7439 16.0337 11.7439H17.7185C17.7185 11.8687 17.7185 12.0143 17.6977 12.1599C17.5105 15.1135 15.0977 17.5055 12.1441 17.6927C8.4625 17.9215 5.4465 14.8015 5.8209 11.1199C6.1121 8.37426 8.2753 6.16946 11.0001 5.83666C12.1441 5.69106 13.2465 5.87826 14.2033 6.31506C14.5153 6.46066 14.8897 6.33586 15.0561 6.04466L15.8049 4.79666C16.0129 4.46386 15.8673 4.00626 15.5137 3.83986C14.2865 3.25746 12.9137 2.94546 11.4577 3.00786C6.9441 3.15346 3.2417 6.77266 3.0129 11.2655C2.7425 16.2991 6.7569 20.5007 11.7489 20.5007C16.5745 20.5215 20.5057 16.5903 20.5057 11.7439Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.c8de0288.svg";
export { ForwardRef as ReactComponent };